import styled, { spacing } from "@rentiohq/web-theme";

export const ForRentSignWrapper = styled.div`
  padding-left: ${spacing("tight")};
`;
